import { cn } from '../../lib/utils.ts';
import seasonalLogo from './plato-logo-seasonal.png';

type Props = {
    className?: string;
};

/**
 * Seasonal variant of the Plato mark, shown in the main navigation during the
 * windows defined in `lib/seasonal-logo.ts`. Swap the artwork (the imported PNG)
 * per holiday.
 */
export function PlatoLogoSeasonal({ className = '' }: Props) {
    return <img src={seasonalLogo} alt="Plato" className={cn('h-7 w-auto', className)} />;
}
